import reducer from './reducers';

export { default as rootActions } from './actions';
export { default as rootSelectors } from './selectors';
export { default as rootSagas } from './sagas';
export { default as rootTypes } from './types';

export default reducer;
